if (!customElements.get('grextor-volume-pricing')) {
  customElements.define('grextor-volume-pricing', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', (event) => {
        const tier = event.target.closest('[data-quantity]');
        const input = this.quantityInput();
        if (!tier || !input || tier.disabled) return;
        input.value = tier.dataset.quantity;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      }, options);
      this.section?.addEventListener('input', () => this.sync(), options);
      this.section?.addEventListener('change', () => this.sync(), options);
      this.section?.addEventListener('on:variant:change', () => this.sync(), options);
      queueMicrotask(() => { if (this.isConnected) this.sync(); });
    }
    disconnectedCallback() { this.controller?.abort(); }
    quantityInput() { return this.section?.querySelector('.js-product-form-main [name="quantity"]'); }
    sync() {
      const input = this.quantityInput();
      if (!input) return;
      const quantity = Math.max(1, Number(input.value) || 1);
      const tiers = [...this.querySelectorAll('[data-quantity]')];
      const selected = tiers.filter((tier) => Number(tier.dataset.quantity) <= quantity).pop();
      const maximum = input.max ? Number(input.max) : Infinity;
      tiers.forEach((tier) => {
        tier.setAttribute('aria-pressed', String(tier === selected));
        tier.disabled = Number(tier.dataset.quantity) > maximum;
      });
      const percent = Number(selected?.dataset.percent || 0);
      const status = this.querySelector('.gx-volume__status');
      status.textContent = percent ? `${quantity} selected · ${percent}% quantity savings` : `${quantity} selected · Standard price`;
    }
  });
}
